import http from "../common/services/httpService";
import {
  MayorAuthorizationHistoryPreviewDto,
  MayorAuthorizationPreviewDto,
  MayorAuthorizationSearchResultDto,
} from "../interfaces/MayorAuthorization";
import { AxiosResponse } from "axios";

const apiEndpoint = "/mayorAuthorization";

const getMayorAuthorizationsAsync = async (
  query: string
): Promise<AxiosResponse<Array<MayorAuthorizationSearchResultDto>>> => {
  return await http.get<Array<MayorAuthorizationSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getMayorAuthorizationsCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getMayorAuthorizationAsync = async (id: number): Promise<AxiosResponse<MayorAuthorizationPreviewDto>> => {
  return await http.get<MayorAuthorizationPreviewDto>(`${apiEndpoint}/${id}`);
};

const getMayorAuthorizationHistoryAsync = async (
  id: number
): Promise<AxiosResponse<MayorAuthorizationHistoryPreviewDto>> => {
  return await http.get<MayorAuthorizationHistoryPreviewDto>(`${apiEndpoint}/history/${id}`);
};

export default {
  getMayorAuthorizationsAsync,
  getMayorAuthorizationsCountAsync,
  getMayorAuthorizationAsync,
  getMayorAuthorizationHistoryAsync,
};
